<template>
  <BreadCrumb PageTitle="Factures transporteurs" />
  <TransportInvoices />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import TransportInvoices from "../../components/Transports/TransportInvoices.vue";

export default defineComponent({
  name: "TransportInvoicesPage",
  components: {
    BreadCrumb,
    TransportInvoices,
  },
});
</script>
